import notificationService from "@/services/notificationService";

const state = {
  items: [],
  unreadCount: 0,
  drawerOpen: false,
  loading: false,
  activeFilter: "all",
  loginContext: null,
  pollingInterval: null
};

const getters = {
  hasUrgent: state =>
    state.items.some(n => n.severity === "urgent" && !n.is_read),
  urgentItems: state =>
    state.items.filter(n => ["urgent", "warning"].includes(n.severity)),
  infoItems: state =>
    state.items.filter(n => ["opportunity", "info"].includes(n.severity)),
  activeItems: state => {
    if (state.activeFilter === "urgent") {
      return state.items.filter(n =>
        ["urgent", "warning"].includes(n.severity)
      );
    }
    if (state.activeFilter === "info") {
      return state.items.filter(n =>
        ["opportunity", "info"].includes(n.severity)
      );
    }
    return state.items;
  }
};

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items;
  },
  SET_UNREAD_COUNT(state, count) {
    state.unreadCount = count;
  },
  SET_DRAWER_OPEN(state, val) {
    state.drawerOpen = val;
  },
  SET_LOADING(state, val) {
    state.loading = val;
  },
  SET_ACTIVE_FILTER(state, filter) {
    state.activeFilter = filter;
  },
  SET_LOGIN_CONTEXT(state, ctx) {
    state.loginContext = ctx;
  },
  REMOVE_ITEM(state, id) {
    state.items = state.items.filter(n => n.id !== id);
  },
  MARK_ITEMS_READ(state, ids) {
    if (ids === "all") {
      state.items = state.items.map(n => ({ ...n, is_read: true }));
      state.unreadCount = 0;
    } else {
      state.items = state.items.map(n =>
        ids.includes(n.id) ? { ...n, is_read: true } : n
      );
      state.unreadCount = state.items.filter(n => !n.is_read).length;
    }
  },
  SET_POLLING(state, interval) {
    state.pollingInterval = interval;
  }
};

const actions = {
  async fetchNotifications({ commit, state }) {
    commit("SET_LOADING", true);
    try {
      const res = await notificationService.getNotifications(
        state.activeFilter
      );
      if (res.data && res.data.success) {
        commit("SET_ITEMS", res.data.data || []);
      }
    } catch (e) {
      // silenciar
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async fetchBadge({ commit }) {
    try {
      const res = await notificationService.getBadge();
      if (res.data && res.data.success !== undefined) {
        commit("SET_UNREAD_COUNT", res.data.count || 0);
      }
    } catch (e) {
      // silenciar
    }
  },

  async markRead({ commit, dispatch }, ids) {
    try {
      await notificationService.markRead(ids);
      commit("MARK_ITEMS_READ", ids);
      dispatch("fetchBadge");
    } catch (e) {
      // silenciar
    }
  },

  async dismiss({ commit, dispatch }, id) {
    try {
      await notificationService.dismiss(id);
      commit("REMOVE_ITEM", id);
      dispatch("fetchBadge");
    } catch (e) {
      // silenciar
    }
  },

  openDrawer({ commit, dispatch }) {
    commit("SET_DRAWER_OPEN", true);
    dispatch("fetchNotifications");
  },

  closeDrawer({ commit }) {
    commit("SET_DRAWER_OPEN", false);
  },

  setFilter({ commit, dispatch }, filter) {
    commit("SET_ACTIVE_FILTER", filter);
    dispatch("fetchNotifications");
  },

  setLoginContext({ commit }, ctx) {
    commit("SET_LOGIN_CONTEXT", ctx);
  },

  startPolling({ commit, dispatch }) {
    dispatch("fetchBadge");
    const interval = setInterval(() => {
      if (document.visibilityState !== "hidden") {
        dispatch("fetchBadge");
      }
    }, 2 * 60 * 1000); // 2 min
    commit("SET_POLLING", interval);
  },

  stopPolling({ state, commit }) {
    if (state.pollingInterval) {
      clearInterval(state.pollingInterval);
      commit("SET_POLLING", null);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
